




































































import { Component, Vue, Ref, Prop } from 'vue-property-decorator';

export interface ISnotrVideo {
  id: string;
  title: string;
  breakpoints?: { time: string; title: string }[];
}

@Component({
  components: {
    Youtube: () => import('vue-youtube').then(module => module.Youtube),
  },
})
export default class VideoPopup extends Vue {
  @Prop({ type: Boolean, default: false }) private autoplay!: boolean;
  @Prop({ type: String }) private defaultVideoId?: string;
  @Prop({ type: Array, default: () => [] }) private videos!: ISnotrVideo[];
  @Prop({ type: String, default: '00:00' }) private start!: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Ref() private readonly youtube!: any;

  private currentVideo: ISnotrVideo | null = null;
  private showTutorial = false;

  public mounted() {
    if (this.defaultVideoId) {
      const video = this.videos.find(v => v.id === this.defaultVideoId);
      if (!video) return;
      this.currentVideo = video;
    } else {
      this.currentVideo = this.videos[0];
    }
  }

  private skipTo(time: string): void {
    const seconds = this.toSeconds(time);
    this.youtube.player.seekTo(seconds);
  }

  private toSeconds(time: string): number {
    const value = this.$dayjs(time, 'mm:ss', true);
    const minutes = value.minute();
    const seconds = value.second();
    return this.$dayjs.duration({ minutes, seconds }).asSeconds();
  }
}
